import { InjectionToken } from '@angular/core';
import { AosEditOnlineService } from '@adw/projects/aca-content/ms-office/src/aos-extension.service';

export const RAW_AOS_SERVICE = new InjectionToken<AosEditOnlineService>(
  'RAW_AOS_SERVICE'
);
